import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { useDispatch } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import { getWeather } from './Redux/weatherSlice';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import axios from 'axios';
import Navbar from './pages/home/Navbar';
import WeatherBar from './components/WeatherBar';
import NotFound from './pages/notFound/NotFound';
import Home from './pages/home/Home';
import RecipeList from './pages/recipe/recipeList';
import Expense from './pages/expense/expense';
import Details from './pages/expense/details';
import Camping from './pages/camping/camping';
import Booking from './pages/booking/booking';
import ManageBooking from './pages/booking/manage';
import Profile from './pages/profile/profile';
import liff from '@line/liff';

function App() {
	const dispatch = useDispatch();
	const [user, setUser] = useState();
	useEffect(() => {
		fetchWeather();
		if (window.location.pathname === '/profile') {
			liff
				.init({ liffId: '2006066572-J30jR9kB' })
				.then(() => {
					console.log('LIFF initialized');
					getUser();
				})
				.catch((err) => {
					console.error('LIFF Initialization failed', err);
				});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getUser = () => {
		liff
			.getProfile()
			.then((profile) => {
				const name = profile.displayName;
				setUser(name);
			})
			.catch((err) => {
				console.log('get profile error', err);
			});
	};

	function fetchWeather() {
		axios
			.get(
				'https://d1-tutorial.a29098477.workers.dev/api/weather?lat=25.0651335306964&lon=121.576200811347'
			)
			.then((response) => {
				let data = {};
				data['main'] = response.data.main;
				data['des'] = response.data.weather;
				data['name'] = response.data.name;
				dispatch(getWeather(data));
			})
			.catch((error) => {
				console.error(error);
			});
	}

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<LocalizationProvider dateAdapter={AdapterMoment}>
				<BrowserRouter>
					<div className='App'>
						{window.location.pathname === '/profile' ? null : (
								<div className='topbar-stack'>
									<Navbar />
									<WeatherBar />
								</div>
							)}
						<div className='content'>
							<Routes>
								<Route exact path='/' element={<Home />}></Route>
								<Route path='*' element={<NotFound />}></Route>
								<Route path='/recipe' element={<RecipeList />}></Route>
								<Route path='/expense' element={<Expense />}></Route>
								<Route path='/expense/details' element={<Details />}></Route>
								<Route path='/camping' element={<Camping />}></Route>
								<Route path='/booking' element={<Booking />}></Route>
								<Route path='/booking/manage' element={<ManageBooking />}></Route>
								<Route path='/profile' element={<Profile user={user} />}></Route>
							</Routes>
						</div>
					</div>
				</BrowserRouter>
			</LocalizationProvider>
		</ThemeProvider>
	);
}

export default App;
